import { render, staticRenderFns } from "./SmsRead.vue?vue&type=template&id=0a6f52fb&"
import script from "./SmsRead.vue?vue&type=script&lang=js&"
export * from "./SmsRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports